import { domain } from 'modules/data';

import { enforcementOptions } from './OrganisationInfo.config';

export const compareByCodeLowerCase = (currencyA: domain.Currency, currencyB: domain.Currency) => {
    return currencyA.code.localeCompare(currencyB.code.toLowerCase());
};

export const filterTwoFaEnforcementOptions = (enforcementType?: domain.TwoFaEnforcementType) => {
    return enforcementOptions.filter((option) => {
        if (enforcementType === domain.TwoFaEnforcementType.Hard) {
            return option.id === domain.TwoFaEnforcementType.Hard;
        }

        if (enforcementType === domain.TwoFaEnforcementType.Soft) {
            return option.id !== domain.TwoFaEnforcementType.None;
        }

        return true;
    });
};
